import { render, staticRenderFns } from "./wechatBindQrCodeDialog.vue?vue&type=template&id=64e627ca&scoped=true"
import script from "./wechatBindQrCodeDialog.vue?vue&type=script&lang=js"
export * from "./wechatBindQrCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./wechatBindQrCodeDialog.vue?vue&type=style&index=0&id=64e627ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e627ca",
  null
  
)

export default component.exports